<template>
    <div class="px-2">
        <!-- <v-card tile outlined class="custom_questions-card"> -->
            <v-toolbar flat>
                <!-- <v-toolbar-title><b>Questions</b></v-toolbar-title>-->
                <v-spacer></v-spacer> 
                <router-link to="/admin/addquestion" style="text-decoration:none;">
                    <v-btn color="secondary" type="submit">
                        Add Question
                    </v-btn>
                </router-link>
            </v-toolbar>

<div >

<v-tabs slider-color="#8e79cc" color="#8e79cc" left v-model="tab">
    <v-tab href="#tab-1" color="#8e79cc">
        Questions
    </v-tab>
    <v-tab href="#tab-2" color="#8e79cc">
        Modify Thaats
    </v-tab>
</v-tabs> 



  <!-- <tabs class="tabs-component-tabs tabs-component tabs-component-tab"> -->
    <!-- <tab name="Questions" id="tab1" class=""> -->
             <!-- <v-toolbar-title><b>Questions</b></v-toolbar-title> -->
                <!-- <v-spacer></v-spacer> -->
    <v-tabs-items v-model="tab">
        <v-tab-item :value="'tab-1'">

        <v-card tile outlined class="custom_questions-card">
            <div class="custom-bg_questions">
                <v-row class="pa-2" no-gutters>
                    <v-spacer></v-spacer>
                    <div class="mr-3"> Search: </div>
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            prepend="search"
                            type="text"
                            dense
                            v-model="search"
                            single-line
                            hide-details
                            outlined
                            no-gutters
                            height="5"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                    dense
                    fixed-header
                    :headers="headers" 
                    bold
                    :items="questions"
                    :items-per-page="10"
                    sort-by="['serialNum', 'questionId', 'questionTitle','questionDescription','questionStatus']"
                    :search="search"
                >
                    <template v-slot:item.serialNum="{item}">
                        {{questions.indexOf(item)+1}} 
                    </template>
                    <template v-slot:item.questionAudio="{item}">
                        <template v-if="item.questionAudio===''&&item.questionKeySequence.length===0">
                           No Audio Provided
                        </template>

                        <template v-else-if="item.questionAudio===''&& item.questionKeySequence.length!==0">
                            Key Sequence Provided
                        </template>
                            <audio v-else
                                ref="audioElm" 
                                :src='`${url}/uploads/`+item.questionAudio' 
                                controls
                                max-height="50"
                                min-height="50"
                                max-width="150"
                                min-width="150"
                                contain
                                elevation
                            >
                            </audio>
                        </template>
                        <template v-slot:item.questionStatus="{item}">
                            <v-switch
                                v-model="item.questionStatus"
                                inset
                                dense
                                class="mt-2" 
                                color="blue"
                                @change="saveQuestionStatus(item._id, item.questionStatus, item.questionType)"
                                :label="item.questionStatus ? 'Active' : 'Inactive'"
                            >
                            </v-switch>
                        </template>
                        <template v-slot:item.delete_viewDetail="{item}"> 
                            <v-tooltip bottom>
                                <template v-slot:activator="{on}">
                                    <v-icon
                                        class="mr-2"
                                        color="blue darken-3"
                                        v-on="on"
                                        @click="goToQuestionInfoEdit(item, item.questionType)"
                                    >mdi-pencil
                                    </v-icon>
                                </template>
                                <span>View Details</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{}">
                                    <v-icon
                                        class="mr-2"
                                        color="blue darken-3"
                                        v-on:click="deleteQuestion(item._id, questions.indexOf(item), item.questionType)"
                                    >mdi-delete
                                    </v-icon>    
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </div>
                </v-card>
        </v-tab-item>
             <!-- </tab> -->


             <!-- <tab name=" Modify Thaats" > -->
            <v-tab-item :value="'tab-2'">
                <v-dialog persistent v-model="editTextDialog" width="900" height="800">
                    <EditText :editedText="toBeEditedText" @changeEditedText="changeEditedText($event)"/>
                </v-dialog>

                 <v-card color="white" tile  class="custom_questions-card">
                    <v-row>
                        <v-col cols="1" class="pt-6 ml-5">
                    Thaats 
                        </v-col>
                        <v-col class="pt-6 ml-0">
                    <div style="width:600;height:500" >
                        <span  v-for="(itm, indx) in thaat.thaatMaster" :key='indx'>
                            <v-chip :key="indx" close @click:close="deleteKeyThaat(indx)">
                                {{itm}}  
                            </v-chip>
                        </span> 
                    </div>
                        </v-col>
                    </v-row>

            <v-row no-gutters class="mt-5">
          <!-- <v-col cols="2" align="center"> -->
               <v-col cols="1" class="pt-0 ml-2">
                    <v-card-text>
                <!-- class="ml-2" -->
                        Add Thaat
                    </v-card-text>
                </v-col>
                <v-col cols="4" align="left" >
                    <v-text-field
                        v-model="singleThaat"
                        outlined
                        dense 
                        clearable
                        @click="editTextThaat($event)"
                        class="ml-1"
                    ></v-text-field>
                </v-col>
            </v-row> 

        <v-row>
            <v-col cols="4" class="mx-5 my-5">
            <v-btn color="secondary" type="submit" @click="putThaats()" :disabled="disabled">
                Submit Thaat List
            </v-btn>
            </v-col>
        </v-row>

        <v-row v-if="errorMessage || successMessage">
                <v-col cols="6" offset-md="2">
                  <v-alert v-if="errorMessage" type="error">
                    {{errorMessage}}
                  </v-alert>
                  <v-alert v-if="successMessage" type="success">
                    {{successMessage}}
                  </v-alert>
                </v-col>
              </v-row>
            </v-card>
            </v-tab-item>
         </v-tabs-items> 
             <!-- </tab> -->
            <!-- </tabs> -->
        </div>
           <!-- </v-card> -->
        </div>
</template>

<script>

import TypeOneQuestion from "../../models/TypeOneQuestion";
import LessonQuestionMapping from "../../models/LessonQuestionMapping";
import EditText from "../../components/admin/EditText";
import Thaat from "../../models/Thaat";
import url1 from '../../../config.js';
import { mapMutations } from "vuex";
//import Vue from 'vue';
//import {Tabs, Tab} from 'vue-tabs-component';

//Vue.component('tabs', Tabs);
//Vue.component('tab', Tab);
export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                  {
                    vm.$router.push("/");
                  }  
            }, 0);
        });
    },
    name: "Questions",
    components:{
        EditText
    },
    data() {
        return {
            search:'',
            headers: [
                { text: "S.No", value: "serialNum" },
                { text: "Question Id", value: "questionId" },
                { text: "Question Type", value: "questionType" },
                { text: "Statement", value: "questionStatement" },
                { text: "Audio", value: "questionAudio" },
                { text: "Status", value: "questionStatus" },
                { text: "", value: "delete_viewDetail" }
            ],
            questions: [],
            question: new TypeOneQuestion(),
            url:url1.url,
            thaat:new Thaat(),
            singleThaat:'',
            inputType:'',
            toBeEditedText:'',
            editTextDialog:false, 
            errorMessage:'',
            successMessage:'',
            disabled:false,
            tab:null,
            //thaatMaster:[],
            };
    },

    methods: {
         ...mapMutations(["setQuestion"]),
        getQuestions() {
            TypeOneQuestion.get(this.auth.token)
                .then(res => {
                    this.questions = res.data;
                    console.log('questions to check', this.questions);
                })
                .catch(err => console.error(err.response.data));
        },
        saveQuestionStatus(question_id, status, questionType)
        {
            LessonQuestionMapping.putQuestionStatusonMasterStatusChange( question_id, status, questionType,  this.auth.token).then(res=>{//(this.auth.token,before course_id
                console.log('res', res.data);
            }).catch(err => {
                console.error(err.response.data)
            });
        },
        deleteQuestion(question_id, index, questionType)
        {

            console.log('token', this.auth.token);
            LessonQuestionMapping.deleteQuestion(question_id, questionType, this.auth.token).then(res=>
            {
                console.log(res.data);
                console.log('index', index);
                //this.questions=res.data;
                this.questions.splice(index, 1);

            }).catch(err => 
            {
                console.error('error', err.response.data)
            });
            
        },

        goToQuestionInfoEdit(questionItem, questionType){
            this.setQuestion({...questionItem, questionType:questionType, question_id:questionItem._id});
            console.log('gotoquestioninfoedit', this.$store.state.question);
            this.$router.replace("/admin/questioninfoedit");
            
        },

        getThaats(){
            Thaat.getThaats(this.auth.token).then(res=>{
                this.thaat=res.data;
                console.log('this.thaatmaster' , this.thaat.thaatMaster);
            }).catch(err=>console.error(err));
        },

        putThaats(){
            this.disabled = true;
            Thaat.putThaats(this.thaat, this.auth.token).then(res=>{
               this.thaat=res.data;
               console.log('put thaat value', this.thaat.thaatMaster);
               this.disabled = false;
               this.successMessage = 'Thaats saved successfully';
               setTimeout(() => (this.successMessage = ""), 5000);
            }).catch(err=>{
                this.errorMessage = err.response.data;
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
            })
        },

        deleteKeyThaat(index){
            this.thaat.thaatMaster.splice(index, 1);
        },

        editTextThaat(e){
            this.textField=e.target;
            this.textField.blur();
            this.inputType="thaat"
            this.toBeEditedText=this.singleThaat;
            this.editTextDialog=true;
        },

         changeEditedText(editedText) {
            if(editedText===null)
            {  
                this.editTextDialog=false;
            }
          else
            {
              //console.log("Selected: "+ this.inputType );
              this.toBeEditedText=editedText;//so that if the value is not changed it takes up this
              if(this.inputType == 'thaat') 
                {
                  this.singleThaat = editedText;
                 // console.log('empty text', editedText)
                  if((editedText.length!==0) && (editedText!==undefined))
                  {
                      console.log('test empty string');
                      this.thaat.thaatMaster.push(editedText);
                  }
                  this.editTextDialog = false;
                }
            }            
        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },
    // watch:{},

    mounted() {
        this.getQuestions();
        this.getThaats();
    }
 }

</script>

<style scoped>
.theme--light.v-card {
    background: transparent;
    border: 0;
}
.custom_questions-card >>> header {
    background: transparent !important;
}
.custom_questions-card >>> header .v-toolbar__content {
    padding: 0;
}
.custom-bg_questions {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 3px solid #d2d6de;
}
.custom_questions-card >>> .v-data-table-header__icon {
    margin-left: 10px;
}
.custom_questions-card >>> .v-data-table-header > tr > th {
    font-size: 14px;
    padding:0 4px;
}
.custom_questions-card >>> .v-data-footer {
    margin: 0;
    font-size: 14px;
}
.custom_questions-card >>> .v-input__slot {
    min-height: 32px !important;
}
.custom_questions-card >>> table{
    border-radius: 0;
    border-collapse: collapse;
    border:0!important;
}
.custom_questions-card >>> table tr td,
.custom_questions-card >>> table tr th {
    border: 1px solid rgba(0, 0, 0, 0.12)!important;
    box-shadow: none!important;
}
.custom_questions-card >>> .v-data-table__wrapper table  tbody > tr > td:last-child,
.custom_questions-card >>> .v-data-table__wrapper table  thead > tr > th:last-child{
    text-align: center!important;
}
.custom_questions-card >>> .v-data-footer{
    border:0;
}
@media only screen and (max-width:992px){
    .custom_questions-card >>> .v-data-table-header > tr > th {
        font-size:12px;
    }
     .custom_questions-card >>> .v-data-table-header > tr > th:first-child {
         min-width: 65px;
    }
     .custom_questions-card >>> .v-data-table-header > tr > th:nth-child(2), .custom_orders-card >>> .v-data-table-header > tr > th:nth-child(3) {
         min-width: 105px;
    }
}

</style>
